<template>
  <main class="about">
    <!-- Hero -->
    <section class="hero" aria-labelledby="page-title">
      <div class="section__inner hero__inner">
        <h2 id="page-title">협회 소개</h2>
        <p><strong>ICI Korea </strong> Recognizing Competency World-Wide</p>

      </div>
    </section>

    <!-- Tabs -->
    <section aria-label="About Navigation" class="about-tabs">
      <div class="section__inner">
        <nav class="tabs">
          <button :class="{ active: activeTab === 'intro' }" @click="goTab('intro')">협회 소개</button>
          <button :class="{ active: activeTab === 'greeting' }" @click="goTab('greeting')">협회장 인사말</button>
          <button :class="{ active: activeTab === 'history' }" @click="goTab('history')">연혁</button>
          <button :class="{ active: activeTab === 'organization' }" @click="goTab('organization')">조직도/임원</button>
        </nav>
      </div>
    </section>

    <!-- 탭 내용 -->
    <Intro v-if="activeTab === 'intro'" />
    <Greeting v-else-if="activeTab === 'greeting'" />
    <History v-else-if="activeTab === 'history'" />
    <Organization v-else-if="activeTab === 'organization'" />
  </main>
</template>

<script setup>
import { ref, watch } from "vue"
import { useRoute, useRouter } from "vue-router"

import Intro from "@/pages/about/intro/Intro.vue"
import Greeting from "@/pages/about/greeting/Greeting.vue"
import History from "@/pages/about/history/History.vue"
import Organization from "@/pages/about/organization/Organization.vue"


const router = useRouter()
const route = useRoute()

const validTabs = ["intro", "greeting", "history", "organization"]
const normalize = (t) => (validTabs.includes(t) ? t : "intro")

// URL 쿼리에서 탭 결정 (직접 진입/새로고침 모두 대응)
const activeTab = ref(normalize(route.query.tab))

// URL이 바뀌면 탭도 동기화
watch(
  () => route.query.tab,
  (t) => {
    activeTab.value = normalize(t)
  },
  { immediate: true }
)

// 탭 클릭 시 URL도 함께 갱신 (URL 공유/새로고침 대비)
const goTab = (t) => {
  router.push({ path: "/aboutmain", query: { tab: t } })
}
</script>

<style scoped>
.about {
  display: flex;
  flex-direction: column;
}

/* 기본 여백 및 컨테이너 */
.section__inner {
  max-width: 1200px;
  margin-inline: auto;
  padding: 20px 16px;
}

/* Hero */
.hero {
  background:
    linear-gradient(rgba(13, 6, 20, .65), rgba(13, 6, 20, .65)),
    url('/src/assets/aboutmain.jpeg') center/cover no-repeat;
  color: #fff;
}

.hero__inner {
  padding: 130px 16px;
  text-align: center;
}

.hero h2 {
  font-family: 'Noto Sans KR', sans-serif;
  font-weight: 700;
  color: #fff;
  font-size: 2.5rem;
  text-align: center;
  letter-spacing: -1px;
  line-height: 1.3;
}

.hero p {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
  margin-top: 12px;
  letter-spacing: -0.3px;
  line-height: 1.6;
}

.hero p strong {
  font-size: 1.225rem;
  font-weight: 700;
}

/* 탭 */
.tabs {
  display: flex;
  justify-content: center;
  gap: 1rem;
  border-bottom: 2px solid #e5e5e5;
  padding: 0.5rem 0;
  flex-wrap: wrap; /* ✅ 모바일에서 줄바꿈 허용 */
}

button {
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #444;
  position: relative;
  font-size: 1.1rem;
  font-family: 'Noto Sans KR', sans-serif;
}

button.active {
  color: var(--main-color);
  font-weight: 600;
}

button.active::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 3px;
  background: var(--main-color);
}

/* =====================================
   ✅ 반응형 영역 시작
===================================== */
@media (max-width: 1024px) {
  .hero__inner {
    padding: 100px 20px;
  }

  .hero h2 {
    font-size: 2rem;
  }
}

@media (max-width: 768px) {
  .section__inner {
    padding: 16px;
  }

  .hero__inner {
    padding: 80px 16px;
  }

  .hero h2 {
    font-size: 1.8rem;
  }

  .hero p {
    font-size: 0.95rem;
    line-height: 1.5;
  }

  .tabs {
    gap: 0.5rem;
    padding: 0.5rem;
  }

  button {
    font-size: 1rem;
    padding: 0.5rem 1rem;
  }
}

@media (max-width: 600px) {
  .hero__inner {
    padding: 60px 16px;
  }

  .hero h2 {
    font-size: 1.5rem;
  }

  .hero p {
    font-size: 0.9rem;
  }

  button {
    padding: 0.4rem 0.8rem;
    font-size: 0.9rem;
  }

  .tabs {
    flex-direction: column;
    align-items: center;
  }

  .tabs button {
    width: 100%;
    border-bottom: 1px solid #e5e5e5;
  }

  .tabs button.active::after {
    bottom: 0;
  }
}

</style>
